import React from "react";
import { useTranslation } from "react-i18next";
import "./customIcon.scss";
import classNames from "classnames";

interface IProps {
  src: string;
  size: string;
  colour?: "blue" | "blue-menu" | "white" | "gray";
}

export function CustomIcon(props: IProps) {
  const { src, size, colour } = props;
  const { t } = useTranslation();

  return (
    <div>
      <img
        src={src}
        alt={t("Custom Icon")}
        className={classNames({
          "custom-icon-small": size === "small",
          "custom-icon-medium": size === "medium",
          "custom-icon-large": size === "large",
          [`custom-icon-${colour}`]: colour,
        })}
      />
    </div>
  );
}
